import HttpResponse from "../../../../../utils/http/http.response";

export type OrderOptimizerDetailsOtherResponseItemStepsOrdersPoints = {
  displayName: string;
  time: Date;
  haltingTime: number;
  distance: number;
  driverTime: Date | null;
  driverHaltingTime: number | null;
  driverDrivingTime: number | null;
  driverDistance: number | null;
  lat: number;
  lon: number;
};

export type OrderOptimizerDetailsOtherResponseItemStepsEndToHome = {
  displayName: string;
  driverTime: Date;
  driverDrivingTime: number;
  driverDistance: number;
};

export type OrderOptimizerDetailsOtherResponseItemStepsOrders = {
  points: OrderOptimizerDetailsOtherResponseItemStepsOrdersPoints[];
  totalTime: number;
  haltingTime: number;
  distance: number;
};

export type OrderOptimizerDetailsOtherResponseItemStepsHomeToStart = {
  displayName: string;
  driverTime: Date;
};

export type OrderOptimizerDetailsOtherResponseItemSteps = {
  homeToStart: OrderOptimizerDetailsOtherResponseItemStepsHomeToStart | null;
  orders: OrderOptimizerDetailsOtherResponseItemStepsOrders[];
  endToHome: OrderOptimizerDetailsOtherResponseItemStepsEndToHome | null;
};

export type OrderOptimizerDetailsOtherResponseItemOrdersByDriverSabs = {
  totalTime: number;
  haltingTime: number;
  distance: number;
};

export type OrderOptimizerDetailsOtherResponseItemOrdersByDriverAba = {
  totalTime: number;
  haltingTime: number;
  distance: number;
};

export type OrderOptimizerDetailsOtherResponseItemDriver = {
  driverId: string;
  displayName: string;
  taxiCorporation: string;
  startLat: number;
  startLon: number;
  contractRate: number;
};

export type OrderOptimizerDetailsOtherResponseItemOptimizedStats = {
  contractRate: number;
  totalTime: number;
  haltingTime: number;
  distance: number;
  margin: number;
};

export type OrderOptimizerDetailsOtherResponseItemUnoptimizedStats = {
  contractRate: number;
  totalTime: number;
  haltingTime: number;
  distance: number;
  margin: number;
};

export type OrderOptimizerDetailsOtherResponseItemOrders = {
  humanId: number;
  cargoCompany: string;
  billingModel: string;
  taxiCorporation: string;
  totalTime: number;
  haltingTime: number;
  distance: number;
  startTime: Date;
  planEntryHumanId: number | null;
  driverName: string | null;
  fleetPartner: string | null;
};

export enum OrderOptimizerDetailsOtherResponseItemStatus {
  PENDING = "PENDING",
  INTERESTING = "INTERESTING",
  REJECTED = "REJECTED",
}

export type OrderOptimizerDetailsOtherResponseItem = {
  reviewedBy: string | null;
  reviewedAt: Date | null;
  orders: OrderOptimizerDetailsOtherResponseItemOrders[];
  unoptimizedStats: OrderOptimizerDetailsOtherResponseItemUnoptimizedStats;
  optimizedStats: OrderOptimizerDetailsOtherResponseItemOptimizedStats;
  driver: OrderOptimizerDetailsOtherResponseItemDriver | null;
  ordersByDriverAba: OrderOptimizerDetailsOtherResponseItemOrdersByDriverAba | null;
  ordersByDriverSabs: OrderOptimizerDetailsOtherResponseItemOrdersByDriverSabs | null;
  saAndBsDistance: number | null;
  steps: OrderOptimizerDetailsOtherResponseItemSteps;
  score: number;
  status: OrderOptimizerDetailsOtherResponseItemStatus;
  totalCargoIncome: number;
  totalDriverHaltingCost: number | null;
};

type OrderOptimizerDetailsOtherResponse =
  HttpResponse<OrderOptimizerDetailsOtherResponseItem>;

export default OrderOptimizerDetailsOtherResponse;
